module.exports = __webpack_public_path__ + "static/img/network-error.bcee40d0.png";